const DG_MANAGEMENT_LABEL = /^DG\/.+$/

export const isDGManagementLabel = (label) =>
  typeof label === 'string' &&
  (label === 'DG' || label === 'DG Final' || DG_MANAGEMENT_LABEL.test(label))
